import { SVGProps } from 'react'

export const ResetIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.6979 6.2818C11.9941 4.36694 10.1606 3.00043 7.99947 3.00055C5.24065 3.0007 2.99908 5.23729 2.99893 8.00108C2.99878 10.7599 5.23975 13.0009 7.99892 13.0004C10.1597 13.0006 11.994 11.6339 12.6973 9.71895M12.6979 6.2818L13 4.75018M12.6979 6.2818L11.25 5.75024"
      stroke="#27272A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
